module.exports = function() {
	return new Worker(__webpack_public_path__ + "b51da4af59538b50dc35.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader!./src/utils/worker.js
// module id = 1434
// module chunks = 129